import axios from 'axios';

const checkUser = (loggedInFunc, notLoggedInFunc = () => {}) => {
  const formData = new FormData();
  formData.append('action', 'is_user_logged_in');
  const ajaxUrl = document.querySelector('meta[name="ajax-url"]').getAttribute('content');

  axios.post(ajaxUrl, formData)
    .then((ajaxResponse) => {
      if (ajaxResponse.data) {
        loggedInFunc();
      } else {
        notLoggedInFunc();
      }
    }).catch((e) => {
      console.log(`Error: ${e}`);
    });
};

export default checkUser;
